import FinanceCard from "./components/FinanceCard";
import { useSelector } from "react-redux";
import en from "../../util/locales/en";
import ar from "../../util/locales/ar";
import { useNavigate } from "react-router";

const SmartFinanceSection = () => {
  const navigate = useNavigate();
  const language = useSelector((state) => state.language);
  const t = language === "en" ? en : ar;

  return (
    <div className="about-finance">
      <div className="intro-finance">
        <h1>{t.about.finance.title}</h1>
        <p>{t.about.finance.description}</p>
      </div>
      <FinanceCard
        title={t.about.finance.card1.title}
        description={t.about.finance.card1.text}
        buttonText={t.about.finance.card1.buttonText}
        onClick={() => navigate("/")}
      />
      <FinanceCard
        title={t.about.finance.card2.title}
        description={t.about.finance.card2.text}
        buttonText={t.about.finance.card2.buttonText}
        onClick={() => navigate("/")}
      />
      <FinanceCard
        title={t.about.finance.card3.title}
        description={t.about.finance.card3.text}
        buttonText={t.about.finance.card3.buttonText}
        onClick={() => navigate("/")}
      />
      <FinanceCard
        title={t.about.finance.card4.title}
        description={t.about.finance.card4.text}
        buttonText={t.about.finance.card4.buttonText}
        onClick={() => navigate("/")}
      />
      <FinanceCard
        title={t.about.finance.card5.title}
        description={t.about.finance.card5.text}
        buttonText={t.about.finance.card5.buttonText}
        onClick={() => navigate("/")}
      />
    </div>
  );
};

export default SmartFinanceSection;
